export default {
  invoice_no: 'Número de factura',
  click_to_upload_image_for_your_logo: 'Haga clic para subir su logo',
  edit_form_welcome_description: 'Editar mensaje de bienvenida',
  page_no: 'Número de página',
  page_link: 'Enlace de la página',
  page_qr: 'Código QR de la página',
  scan_open_payment_page: 'Escanee el código QR para acceder a la página de pago',
  create_new_link: 'Crear nuevo enlace',
  create_new_page: 'Crear nueva página',
  transaction_amount: 'Monto de la transacción',
  total_transaction_amount: 'Monto total de transacciones',
  total_quantity: 'Cantidad total'
}
